import { Alert } from "@cvpartner/design-system";
import type React from "react";
import { I18n } from "@/util/translations.ts";
import { Login } from "./Login.tsx";

export const Timeout: React.FC = () => (
  <Login
    alert={
      <Alert type="warning" title={I18n.t("signin.alert.signout_inactivity")} />
    }
    type="normal"
  />
);
